// @flow

import React, { Fragment, useCallback, useState, cloneElement, Children } from 'react';
import type { Node } from 'react';
import { Heading } from '@riseart/common';
import { Overlay, OverlayHeader, OverlayBody, OverlayContainer } from '@riseart/layout';

type Props = {
  title: Node | string,
  component: Node,
  children: Node,
  open?: boolean,
  onToggle?: Function,
};

export function EnquireOverlay({
  open,
  title,
  children,
  component: RenderedForm,
  onToggle,
}: Props): Node {
  const [isOpened, setIsOpened] = useState(open);
  const handleClose = useCallback(
    (e: Event) => {
      e.preventDefault();
      const newState = !isOpened;
      setIsOpened(newState);

      if (typeof onToggle === 'function') {
        onToggle(newState);
      }
    },
    [isOpened, onToggle],
  );
  const actionElement = cloneElement(Children.only(children), {
    onClick: handleClose,
  });

  return (
    <Fragment>
      {actionElement}
      {isOpened ? (
        <Overlay isVisible type="semitransparent" size="medium" onClose={handleClose}>
          <OverlayContainer>
            <OverlayHeader border={false}>
              <Heading tag="h3" level="3">
                {title}
              </Heading>
            </OverlayHeader>
            <OverlayBody>
              <RenderedForm onClose={handleClose} />
            </OverlayBody>
          </OverlayContainer>
        </Overlay>
      ) : null}
    </Fragment>
  );
}
